export default __webpack_public_path__ + "static/media/Automated-Material-Flow.ea9d3877.pdf";